import React, { Component } from 'react';
import { connect } from 'react-redux'
import { closePopup } from '../../../actions/popup';
import querystring from 'querystring';
import { receiveItems } from '../../../actions/comment/guestbookComment'
import {jsonResponseHandler} from "../../../utils/FetchHelper";
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({
    items: state.guestbookComment.item.items,
    isCommentBlockPopupOpened: state.popup.isCommentBlockPopupOpened,
    id: state.popup.commentBlockPopupCommentIds
}), dispatch => ({
    handlePopupClose: () => {
        dispatch(closePopup())
    },
    handleReceiveItems: (items, totalCount) => {
        dispatch(receiveItems(items, totalCount))
    },
    dispatch
}))
class GuestBookCommentBlockPopup extends Component {
    constructor() {
        super();
        this.state = {
            blockName : true,
            blockIp : false
        };

        this.handleBlockNameChange = this.handleBlockNameChange.bind(this);
        this.handleBlockIpChange = this.handleBlockIpChange.bind(this);
        this.handleBlockComments = this.handleBlockComments.bind(this);
        this.reFetchItems = this.reFetchItems.bind(this);
    }

    handleBlockNameChange(e) {
        this.setState({blockName: e.target.checked});
    }

    handleBlockIpChange(e) {
        this.setState({blockIp: e.target.checked});
    }

    handleBlockComments(e) {

        const { dispatch } = this.props;

        fetch(addPrefix("/manage/guestBookComments/blocking.json"), {
            method: "post",
            credentials: "include",
            headers: {'Content-Type':'application/x-www-form-urlencoded'},
            body: querystring.stringify({
                blockName: this.state.blockName,
                blockIp: this.state.blockIp,
                ids: this.props.id
            })
        })
            .then(jsonResponseHandler(dispatch))
            .then(data => {
                this.props.handlePopupClose();
                this.reFetchItems();
            })
            .catch(e => {
                console.log(e)
            })
    }

    reFetchItems() {

        const { dispatch } = this.props;

        fetch(addPrefix("/manage/guestBookComments.json") + location.search, {
            method: 'GET',
            credentials: 'include'
        })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                this.props.handleReceiveItems(data.items, data.totalCount)
            })
            .catch(e => {
                console.log(e)
            })
    }

    render() {
        return (
            <div className="blog_layer" style={{position: 'fixed', top: '50%', marginTop: '-112px', display: this.props.isCommentBlockPopupOpened?'block':'none'}}>
                <div className="inner_blog_layer inner_blog_layer1">
                    <form>
                        <div className="cont_layer">
                            <strong className="tit_popup">스팸 차단</strong>
                            <span className="txt_popup">스팸필터에 차단 정보를 등록하고 해당 정보로 등록된 댓글은 휴지통으로 보냅니다.</span>
                            <div className="bundle_check">
                                <div className="check_blog">
                                    <input type="checkbox" id="inpCheck1" className="inp_check" defaultChecked={true} onChange={this.handleBlockNameChange}/>
                                        <label htmlFor="inpCheck1" className="lab_check">
                                            <span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
                                            <span className="txt_check">작성자 차단</span>
                                        </label>
                                </div>
                                <div className="check_blog">
                                    <input type="checkbox" id="inpCheck2" className="inp_check" onChange={this.handleBlockIpChange}/>
                                        <label htmlFor="inpCheck2" className="lab_check">
                                            <span className="ico_blog ico_checkbox">선택 됨/선택 안됨</span>
                                            <span className="txt_check">IP 차단</span>
                                        </label>
                                </div>
                            </div>
                        </div>
                        <div className="fld_btn">
                            <button type="button" className="btn_cancel" onClick={()=>{this.props.handlePopupClose()}}>취소</button>
                            <button type="button" className="btn_default" onClick={this.handleBlockComments}>확인</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default GuestBookCommentBlockPopup;
